/**
 * Edge shadow for the board's sticky columns. The table has no vertical
 * borders, so once a group scrolls sideways nothing else separates the pinned
 * Item column from the cells sliding under it. The scroll-sync loop in
 * `TrackersBoardTable` sets `data-scrolled` on each group's scroll wrapper
 * (`group/hscroll`); the shadow shows only while that is true. Same edge as
 * the content-studio output table's pinned column.
 */
export const STICKY_EDGE_SHADOW =
  'after:pointer-events-none after:absolute after:inset-y-0 after:left-full after:w-2 ' +
  'after:bg-linear-to-r after:from-foreground/10 after:to-transparent after:opacity-0 ' +
  'after:transition-opacity after:duration-fast group-data-[scrolled=true]/hscroll:after:opacity-100';
